import { useMemo } from 'react';

import { type LeadStageType } from '@ekhodealer/ekho-common';

import { KanbanBoard } from '@common/components/Kanban/KanbanBoard';

import { useManageLeads } from '../hooks/useManageLeads';
import { getStageAccent } from '../utils/utils';

import { LeadCard } from './LeadCard';

export const LeadsKanbanBoard = () => {
	const { columnsData, loadMore, moveItem } = useManageLeads();

	// Convert our data format to the KanbanBoard format
	const kanbanColumns = useMemo(
		() =>
			columnsData.map((column) => {
				const accent = getStageAccent(column.id as LeadStageType);
				return {
					id: column.id,
					title: column.title,
					dropMessage: column.dropMessage,
					items: column.items.map((item) => ({
						id: item.id,
						columnId: column.id,
						cardData: item,
					})),
					count: column.totalItemCount,
					hasMoreItems: column.hasMoreItems,
					...(typeof accent === 'number' ? { accent } : {}),
				};
			}),
		[columnsData],
	);

	return (
		<KanbanBoard
			columns={kanbanColumns}
			cardComponent={(leadData, isDragging) => (
				<LeadCard leadData={leadData} isDragging={isDragging} />
			)}
			onItemMove={async (moveInfo) => {
				await moveItem(moveInfo.itemId, moveInfo.toColumnId);
			}}
			onLoadMore={loadMore}
		/>
	);
};
